import Dexie, { PromiseExtended } from "Dexie";
import { BoldTable } from "src/app/infra/database/dexie/instance/chat/schema/bold";
import { DexieRepository } from "src/app/infra/repository/dexie/dexie-repository.service";


export abstract class  IBoldLocalRepository extends DexieRepository<BoldTable, BoldTable> implements IBoldLocalRepository {
  abstract open(): PromiseExtended<Dexie>
}
